var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","transform":"rotate(-180 23 17.5)"},[React.createElement("path",{"fill":"currentColor","d":"M17.94 22.94c-.645-.645-.63-1.705.033-2.367l9.6-9.6c.662-.663 1.722-.678 2.366-.034.645.645.63 1.704-.033 2.367l-9.6 9.6c-.663.663-1.722.678-2.367.033z","key":0}),React.createElement("rect",{"width":"3.2","height":"10","x":"16","y":"15","fill":"currentColor","rx":"1.6","key":1}),React.createElement("rect",{"width":"3.2","height":"10","x":"19.6","y":"18.4","fill":"currentColor","rx":"1.6","transform":"rotate(90 21.2 23.4)","key":2})]));
}

Arrow.defaultProps = {"width":"46","height":"35","viewBox":"0 0 46 35"};

module.exports = Arrow;

Arrow.default = Arrow;
